import { combinedActions } from "../../utils/actions";

export const getTotpStatus = combinedActions<void, boolean>("ETTOTPSTATUS");
export const activateTotp = combinedActions<
  void,
  { img: string; secret: string }
>("ACTIVATETOTP");
export const testTotp = combinedActions<string>("TESTTOTP");
